import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";
import { CommonUtil } from "../../util/Utils";

let initialState: any = {
  lookupResponse: {},
};

//Get Lookup API call
export const LookupService = createAsyncThunk(
  "master/lookup",
  async (lookup: any) => {
    try {
      return await getAPI(
        `${CommonEndpoint.lookup}${CommonUtil.appendQueryStr(
          lookup.lookup,
          "types"
        )}`
      );
    } catch (err) {
      return err;
    }
  }
);

const lookupSlice = createSlice({
  name: "lookup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      LookupService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(LookupService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const lookupReducer = lookupSlice.reducer;
export default lookupReducer;
